export default {
    "company_header": "회사 세부 정보",
    "header_product_warning": "적합한 GrabCAD 제품에 등록하고 싶으십니까? {0} 에 등록하십시오.",
    "label": {
        "first_name": "이름",
        "last_name": "성",
        "name": "이름",
        "company_name": "회사 이름",
        "university_name": "학교 이름",
        "role": "역할",
        "company_size": "회사 규모",
        "phone_number": "전화 번호",
        "printer": "3D 프린터를 소유하고 계십니까?",
        "student_printer": "학교에 3D 프린터가 있습니까?",
        "uses_printer_for": "어떤 용도로 3D 프린터를 사용하십니까?",
        "shop_owner": "모델 상점을 관리하는 역할을 맡고 있으십니까?",
        "shop_users_expected": "귀하의 상점에 주문을 제출하는 사람은 몇 명입니까?",
        "email": "이메일",
        "email_confirm": "이메일 확인",
        "email_again": "이메일 다시 입력",
        "password": "암호",
        "country": "위치",
				"state": "주/지역",
        "password_confirm": "암호 확인",
        "password_again": "암호 다시 입력",
        "password_hint": "최소 6자",
        "interested_in": "다음 항목에 관심이 더 있습니다...",
        "industry_vertical": "수직 업계",
        "industry_level": "작업 수준",
        "business_email": "비즈니스 이메일",
        "business_email_confirm": "비즈니스 이메일 확인",
        "recaptcha": "자신이 로봇이 아님을 확인",
        "industry_level_select": "작업 수준 선택",
        "company_size_select": "크기 선택",
        "industry_vertical_select": "수직 업계 선택"
    },
    "placeholders": {
        "name": "예: John Smith",
        "first": "이름",
        "last": "성",
        "email": "이메일 입력",
        "email_confirm": "이메일 다시 입력",
        "password": "암호 입력",
        "company_name": "회사 이름 입력",
        "university_name": "학교 이름 입력",
        "phone_number": "전화 번호 입력",
        "printer": "응답 선택",
        "country": "국가 선택",
				"state": "주 또는 지역을 선택하세요",
        "business_email": "비즈니스 이메일 입력",
        "business_email_confirm": "비즈니스 이메일 확인"
    },
    "terms": {
        "buy_now_text": "\"다음\"을 클릭하면 다음 내용을 읽었음을 확인하는 것이 됩니다.",
        "workbench_text": "\"Workbench 등록\"을 클릭하면 다음 내용을 읽었음을 확인하는 것이 됩니다.",
        "print_text": "\"등록\"을 클릭하면 다음 내용을 읽었음을 확인하는 것이 됩니다.",
        "text": "\"커뮤니티 등록\"을 클릭하면 다음 내용을 읽었음을 확인하는 것이 됩니다.",
        "link": "서비스 약관"
    },
	"software_terms": {
		"link": "소프트웨어 약관"
	},
    "privacy_policy": {
        "and": "및",
        "link": "개인정보 보호정책",
        "text": "그리고 이러한 약관과 정책에 동의하고 이를 준수할 것을 확인하는 것이 됩니다."
    },
    "actions": {
        "next": "다음",
        "workbench_sign_up": "Workbench 등록",
        "sign_up_button": "등록",
        "shop_sign_up": "GrabCAD Shop 무료 체험판 요청하기",
        "sign_up": "커뮤니티 등록",
        "cancel": "취소"
    },
    "error": {
        "name_empty": "이름을 추가하십시오.",
        "email_taken": "이 이메일은 이미 등록되었습니다. 로그인하거나 다른 이메일을 선택하십시오.",
        "email_empty": "이메일을 추가하십시오.",
        "email_nomatch": "이메일이 서로 일치해야 합니다.",
        "email_look": "올바른 이메일을 입력하십시오.",
        "password_nomatch": "암호가 서로 일치해야 합니다.",
        "password_short": "암호가 너무 짧습니다. 길이가 6자 이상이어야 합니다.",
        "password_empty": "암호를 입력하십시오.",
        "recaptcha": "확인란을 클릭하여 자신이 로봇이 아님을 확인하십시오.",
        "country_blocked": "죄송합니다. 귀하는 GrabCAD에 등록할 수 없습니다.",
        "blank": "은(는) 비워 둘 수 없습니다."
    },
    "active": {
        "email": "계정 확인 링크를 받을 실제 이메일을 입력하십시오."
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "아니요. 그럴 계획이 없습니다.",
            "no_but_interesed": "아니요. 하지만 관심이 있습니다.",
            "yes_for_work": "예. 작업용입니다.",
            "yes_as_hobby": "예. 취미입니다.",
            "yes_for_other": "예. 다른 이유입니다."
        },
        "student": {
            "no_dont_plan": "아니요. 우리 학교는 3D 조형에 관심이 없습니다.",
            "no_but_interesed": "아니요. 하지만 우리 학교는 현재 3D 프린터 쇼핑을 하고 있습니다.",
            "yes_they_do": "예",
            "not_sure": "확실하지 않음"
        }
    },
    "uses_printer_for": {
        "professional": "전문 용도",
        "education": "교육/연구",
        "hobby": "취미",
        "dont_use": "3D 프린터를 사용하지 않음"
    },
    "level_values": {
        "administrator_principal_superintendent": "경영지원/행정/관리",
        "biomedical_engineer": "생명공학 연구자",
        "c_level_executive": "기업 경영진",
        "clinical_preclinical": "임상/기초의학",
        "dean_department_head": "학장/학과장",
        "dentist": "치과전문의",
        "designer": "디자이너",
        "educator": "교사/강사",
        "engineer": "엔지니어",
        "equipment_manufacturer": "장비 제조사",
        "lab_owner": "기공소장",
        "lab_technician": "기공사",
        "marketing": "마케팅",
        "medical_education_and_training": "의과 교육 및 수련",
        "parent": "학부모",
        "practicing_physician": "개원의",
        "president_provost": "회장/교무처장",
        "prosthetist_orthotist": "보철/교정전문의",
        "purchasing": "구매",
        "quality": "품질관리",
        "rd_engineering": "R&D/제품개발",
        "sales": "영업",
        "senior_management_administration": "고위 관리/임원",
        "student": "학생",
        "training": "트레이닝",
        "other": "기타",
        "not_employed": "채용되지 않음"
    },
    "industry_values": {
        "aerospace": "항공우주",
        "architecture": "건축",
        "arts_entertainment": "예술과 엔터테인먼트",
        "automotive": "자동차",
        "commercial_products": "상용 제품",
        "consumer_electronics": "소비자 가전",
        "consumer_goods": "소비재",
        "dental": "치과",
        "education": "교육",
        "engineering_consulting_service": "엔지니어링 컨설팅 서비스",
        "government_military": "정부/군사",
        "industrial_equipment": "산업용 장비",
        "jewelry": "보석류",
        "medical_device": "의료 기기 또는 장비",
        "service_bureau": "공공 기관",
        "toys": "장난감",
        "reseller": "소매업",
        "other": "기타"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1000",
        "1,000 - 2,500": "1000 - 2500",
        "2,500 - 5,000": "2500 - 5000",
        "5,000 - 10,000": "5000 - 10000",
        "10,000 - 15,000": "10 000 - 15 000",
        "15,000 - 20,000": "15 000 - 20 000",
        "20,000+": "20 000+",
        "not_company": "회사 아님"
    },
    "yes_no_values": {
        "yes": "예",
        "no": "아니요"
    }
}
